module.exports = __webpack_public_path__ + "img/statistics.6160c20e.svg";